<template>
  <div class="cf-app-layout">
    <div class="cf-app-layout__header">
      <!-- App Simple Header -->
      <app-simple-header />
    </div>

    <!-- App Content -->
    <div class="cf-app-layout__main-content">
      <div class="cf-page-content-container">
        <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16">
          <span class="cf-icon cf-icon--brand-primary cf-icon--large far fa-exclamation-circle" />

          <h2 class="cf-title cf-title--2">
            {{ maintenanceModeContent.title }}
          </h2>

          <p class="title title--4">
            {{ maintenanceModeContent.message }}
          </p>
        </div>
      </div>
    </div>

    <!-- App Footer -->
    <div class="cf-app-layout__footer">
      <cf-app-footer />
    </div>
  </div>
</template>


<script>
  import AppSimpleHeader from '@/view/layout/app-simple-header/index.vue';
  import CfAppFooter from '@/view/components/globals/cf-app-footer/index.vue';


  export default {
    name: 'MaintenancePage',

    components: {
      AppSimpleHeader,
      CfAppFooter
    },

    props: {
      maintenanceModeContent: {
        type: Object,
        default() {
          return {
            title: 'Undergoing Maintenance',
            message: 'Sorry, we are currently undergoing maintenance. Please try again later.'
          };
        }
      }
    }
  };
</script>
